module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  var pagesCount = ~~Math.ceil(widget.gridCount/widget.gridLimit); 
    ; __append("\n\n<a ")
    ; __append(((widget.gridPage == 0) ? "class='selected'" : 'href="javascript:void(0)" on-click="onPrevPageClick"'))
    ; __append(">&#10094;&nbsp;</a>\n\n")
    ;  var dotted = false; 
    ; __append("\n")
    ;  for (var i = 0; i < pagesCount; i++) { 
    ; __append("\n")
    ;  if(i!=0&&i!=(pagesCount-1)&&(i<(widget.gridPage-3)||i>(widget.gridPage+3))) { 
    ; __append("\n")
    ;  if(!dotted) { dotted=true; 
    ; __append("\n<span>...</span>\n")
    ;  } 
    ; __append("\n")
    ;  continue} 
    ; __append("\n<a ")
    ; __append(((i == widget.gridPage) ? "class='selected'" : 'href="javascript:void(0)" on-click="onPageChange"'))
    ; __append(" data-value=\"")
    ; __append(escapeFn(i))
    ; __append("\">")
    ; __append(escapeFn(i+1))
    ; __append("</a>\n")
    ;  dotted = false; 
    ; __append("\n")
    ;  } 
    ; __append("\n\n<a ")
    ; __append(((widget.gridPage == (pagesCount-1)) ? "class='selected'" : 'href="javascript:void(0)" on-click="onNextPageClick"'))
    ; __append(" >&nbsp;&#10095;</a>")
  }
  return __output.join("");

}